import { useEffect, useState } from 'react';
import axios from 'axios';

const url = new URL(window.location.href);
const getImg = url.searchParams.get('background');
const getName = url.searchParams.get('backgroundName');
const getPrice = url.searchParams.get('backgroundPrice');
const getGroupName = url.searchParams.get('groupName');

export const useBackgroundData = (elementId: number, paramSectionId: number) => {

    const domContainer = document.querySelector('#constructor_app'),
        sectionId = domContainer?.getAttribute('data-section-id')
            ? domContainer?.getAttribute('data-section-id')
            : url.searchParams.get('sectionId')
                ? url.searchParams.get('sectionId')
                : paramSectionId;

    async function getBackgroundData() {
        const addParams = sectionId ? 'sectionId=' + sectionId : '';
        return await axios.get('https://fresq.ru/app/ajax/?type=background&' + addParams);
    }

    const [backgroundData, setBackgroundData] = useState({
        img: '',
        backgroundColor: '',
        name: '',
        price: 0,
        groupName: '',
        isSeamless: false,
        isSeamlessMode: false,
        items: [
            {
                id: '',
                groupName: '',
                premPrice: 0,
                price: 0,
                selectedImg: '',
                isPrem: false,
                isSeamlessMode: false,
                excludedOptions: false,
                installPrice: 0,
                minInstallPrice: 0,
                examplePrice: 0,
                exampleExtraPrice: 0,
                colors: [{ img: '', name: '' }],
                premColors: [{ img: '', name: '' }],
            },
        ],
    });

    useEffect(() => {
        let isSubscribed = true;
        if(isSubscribed) {
            const fetchData = async () => {
                await getBackgroundData().then(response => {
                    const newBackgroundData = {
                        img: getImg ? getImg : response.data[0].colors[0].img,
                        backgroundColor: getName && getName[0] + getName[1] + getName[2] === '%23' ? getName.replace('%23', '#') : '',
                        name: getName ? getName : response.data[0].colors[0].name,
                        price: getPrice ? parseInt(getPrice) : response.data[0].price,
                        groupName: getGroupName ? getGroupName : response.data[0].groupName,
                        isSeamless: response.data[0].isSeamless,
                        isSeamlessMode: response.data[0].isSeamlessMode,
                        items: response.data,
                    };

                    setBackgroundData(newBackgroundData);
                });
            }

            fetchData()
                .catch(console.error);
        }

        return () => {
            isSubscribed = false;
        };
    }, [elementId, paramSectionId]);

    return [backgroundData];
};
